import React from 'react';
import Accordion from 'react-bootstrap/Accordion';

export const Faq = ({data}) => {
  const {number, title, items, suptitle} = data;

  return (
    <section className="pt-lg-16 pt-9 pt-md-11 pb-7 pb-md-11">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <span className="zg-label bg-green me-2 mb-4 mb-lg-6">{number}</span>
            <span className="zg-label bg-green mb-4 mb-lg-6">{suptitle}</span>
          </div>
          <div className="col-lg-5">
            <h2 className="h3 mb-6 mb-lg-6 mb-xl-9">{title}</h2>
          </div>
          {items && items.length > 0 && (
            <div className={'col-12 col-xl-10 offset-xl-1'}>
              <Accordion defaultActiveKey="0" className={'zg-faq'}>
                {items.map((item, index) =>
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header as={'h3'}>
                      {item.title}
                      <svg width={14} height={14} className={'accordion-icon'}>
                        <use xlinkHref="#icon-arrow-down-r"></use>
                      </svg>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="zg-text-block" dangerouslySetInnerHTML={{__html: item.text}}></div>
                    </Accordion.Body>
                  </Accordion.Item>)
                }
              </Accordion>
            </div>
          )}

        </div>
      </div>
    </section>
  )
}
